import {useState} from "react";
import {GetEventsRequest, GetEventsResponse, IKensuCalendarEventProto} from "../../provider_api";
import {useRpcSender} from "../RpcSender";
import {RpcState} from "../RpcState";

export const useGetCalendarEvents = () => {

  const rpcSender = useRpcSender();
  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'});
  const [events, setEvents] = useState<IKensuCalendarEventProto[]>([]);

  const send = (request: GetEventsRequest) => {

    setRpcState({state: 'pending'});
    rpcSender.send('get_events', GetEventsRequest.encode(request).finish())
        .then(value => {
          const response = GetEventsResponse.decode(value);
          setRpcState({state: 'success'});
          setEvents(response.events);
        })
        .catch(e => {
          console.log('error', e);
          setRpcState({state: 'error', message: 'Network error loading events'});
        });
  }
  
  return {rpcState, events, send, setEvents}
}